import React, { createContext, useContext } from 'react';
import { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import {
  AdvancedFilterConfig,
  Paths,
  QuestionFilterConfig,
  RankingDisabledReason,
  EducationFilterConfig,
} from 'talent_matching/types';

export interface UserContextValue {
  paths: Paths;
  calibrationTerms: string[];
  canAdvance: boolean;
  canReject: boolean;
  canEmail: boolean;
  canBulkEdit: boolean;
  canCreateCalibrationSetting: boolean;
  canEditAndDeleteTalentMatchingCalibration: boolean;
  canViewTalentMatchingAiMatchScore: boolean;
  canCreateTags: boolean;
  canExport: boolean;
  canUseLocations: boolean;
  locationFilterReadOnly: boolean;
  canParseResumes: boolean;
  canUseFraudFilter: boolean;
  rankingDisabledReason: RankingDisabledReason | null;
  canDownloadCandidateData: boolean;
  isSiteAdmin: boolean;
  userDateFormat: string;
  advancedFilterConfig: AdvancedFilterConfig;
  questionFilterConfig: QuestionFilterConfig;
  educationFilterConfig: EducationFilterConfig;
  activeSidePanelTab: string | null;
  setActiveSidePanelTab: (tab: string) => void;
  feedbackOnly: boolean;
  jobTitle: string;
  appReviewSessionId: number;
  savedSearchOptions: Item[];
  setSavedSearchOptions: (options: Item[]) => void;
  canViewFraudReports: boolean;
  canRunFraudReports: boolean;
  linkedinRscEnabled: boolean;
  canUseSecurityConcerns: boolean;
  userId: number;
  hiringPlanId: number;
}

export const UserContext = createContext<UserContextValue | undefined>(
  undefined
);

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserContext not used within a UserContext.Provider');
  }
  return context;
};

export const UserContextProvider = ({
  value,
  children,
}: {
  value: UserContextValue;
  children: React.ReactNode;
}) => {
  return (
    <UserContext.Provider value={{ ...value }}>{children}</UserContext.Provider>
  );
};
